import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const scrollIntoFocus = (element: HTMLElement | null) => {
    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus();
        element.click();
    }
};

type useScrollIntoFocusProps<T, AccordionKey extends string> = {
    accordions?: {
        state: [Record<AccordionKey, boolean>, React.Dispatch<React.SetStateAction<Record<AccordionKey, boolean>>>];
        fieldsPerAccordion: Record<AccordionKey, (keyof T)[]>;
    };
};

export default function useScrollIntoFocus<T, AccordionKey extends string>({
    accordions,
}: useScrollIntoFocusProps<T, AccordionKey>) {
    const { state } = useLocation();
    const [_accordsionsState, setAccordions] = accordions?.state ?? [null, null];

    useEffect(() => {
        const { focusField } = state || {};

        if (focusField) {
            if (accordions) {
                setAccordions?.((prev) => {
                    const newState = { ...prev };
                    for (const [accordionKey, fields] of Object.entries(accordions.fieldsPerAccordion)) {
                        if ((fields as (keyof T)[]).some((field) => field === focusField)) {
                            newState[accordionKey as AccordionKey] = true;
                        }
                    }
                    return newState;
                });
                setTimeout(() => {
                    const element = document.getElementById(focusField);
                    scrollIntoFocus(element);
                }, 500);
            } else {
                const element = document.getElementById(focusField);
                scrollIntoFocus(element);
            }
        }
    }, [state]);
}
